
export const JOBS_APPLY_GET              = "JOBS_APPLY_GET"
export const JOBS_APPLY_SET              = "JOBS_APPLY_SET"